import { render, staticRenderFns } from "./user.vue?vue&type=template&id=7d220a94&scoped=true&lang=html&"
import script from "./user.vue?vue&type=script&lang=js&"
export * from "./user.vue?vue&type=script&lang=js&"
import style0 from "@assets/css/user.less?vue&type=style&index=0&id=7d220a94&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d220a94",
  null
  
)

component.options.__file = "user.vue"
export default component.exports